export default __webpack_public_path__ + "static/3p8-dicom-ef7805d55cc72ec3e0f3ff8f743ed9b9.png";